import styled from 'styled-components'
import theme from 'theme_'
import { Dropdown } from 'components/Input'
import { Font14, Font16 } from 'components/Typography'
import Icon from '@mdi/react'
import { CommonLinkButton } from 'components/Button'

export const PaginationContainer = styled.div<{ $width?: number }>`
  display: flex;
  flex-wrap: nowrap;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: 8px;
  background: ${theme.colors.white};
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  border-radius: 8px;
  box-shadow: 0px 4px 40px ${theme.colors.commonShadow};
  margin-top: 8px;

  @media ${theme.devices.tablet} {
    position: sticky;
    left: 0;
    z-index: 2;
    width: ${(p) => p.$width + 'px'};
    padding: 8px 16px;
    margin-top: 1px;
    box-shadow: none;
    border-radius: 0 0 8px 8px;
  }
`

export const PaginationControlWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`

export const MobilePaginationControlWrapper = styled(PaginationControlWrapper)`
  @media ${theme.devices.tablet} {
    display: none;
  }
`
export const MobilePaginationControl = styled(CommonLinkButton)`
  display: flex;
  -webkit-appearance: none;
  flex-shrink: 0;
  max-width: 36px;
  padding: 1px 6px;
`

export const PaginationCurrentPage = styled.div`
  ${Font14};
  margin: 0 12px;
  display: flex;
`

export const PaginationIcon = styled(Icon)<{ disabled?: boolean }>`
  height: 24px;
  width: 24px;
  color: ${(p) =>
    p.disabled ? theme.colors.darkeyGrey : theme.colors.horizonOrange};

  @media ${theme.devices.tablet} {
    color: ${theme.colors.darkeyGrey};
    :hover {
      color: ${theme.colors.horizonOrange};
    }
  }
`

export const ReactPaginateWrapper = styled.div`
  display: none;
  ${Font16};
  ul {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    list-style-type: none;
    margin: 0;
    padding: 0;
    height: 100%;

    li {
      height: 100%;
      display: inline;
      margin: 0 4px;
      :focus {
        outline: none;
      }
      a {
        outline: none;
        padding: 8px 16px;
        cursor: pointer;
        :focus {
          outline: none;
        }
      }
    }

    .selected a {
      height: 100%;
      font-weight: 900;
      border-radius: 8px;
      box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
      background: ${theme.colors.accent10};
    }

    .next,
    .previous {
      a {
        padding: 8px 0;
        display: flex;
      }
    }
  }
  @media ${theme.devices.tablet} {
    display: flex;
  }
`

export const MobilePaginationCurrentPage = styled.div`
  ${Font16};
  width: 52px;
  font-weight: 900;
  padding: 8px 16px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.horizonOrange};
  background: ${theme.colors.accent10};
  text-align: center;
`

export const PaginationRowsPerPage = styled(Dropdown)`
  background: ${theme.colors.white};
  box-shadow: inset 0 0 0 1px ${theme.colors.lightGrey};
  border-radius: 8px;
  display: flex;
  transition: all 0.3s ease;
  font-weight: normal;
  ${Font14};
  width: 76px;

  :focus-within {
    box-shadow: inset 0 0 0 1px ${theme.colors.horizonOrange};
  }

  .select__dropdown-indicator {
    color: ${theme.colors.duneWarmGrey};
    padding: 4px 8px;
  }

  .select__menu {
    position: absolute;
    overflow: auto;
    background: ${theme.colors.white};
    box-shadow: 0 4px 40px ${theme.colors.commonShadow};
    border-radius: 8px;

    .select__option--is-selected {
      background: transparent;
    }
  }

  .select__control--is-focused {
    border: none;
    box-shadow: none;
  }

  .select__control {
    min-height: 32px;
    height: 32px;
    width: 100%;
    border: none;
    background: none;

    &:hover {
      border: none;
    }
  }
`
